(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("iXIyd", function(module, exports) {

$parcel$export(module.exports, "MapContainer", function () { return $dce04b913d20622b$export$23f3dfd47374502b; });

var $7CNe0 = parcelRequire("7CNe0");

var $80RSc = parcelRequire("80RSc");

var $dTCkE = parcelRequire("dTCkE");
function $dce04b913d20622b$var$_extends() {
    $dce04b913d20622b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dce04b913d20622b$var$_extends.apply(this, arguments);
}
function $dce04b913d20622b$var$MapContainerComponent({ bounds: bounds, boundsOptions: boundsOptions, center: center, children: children, className: className, id: id, placeholder: placeholder, style: style, whenReady: whenReady, zoom: zoom, ...options }, forwardedRef) {
    const [props] = (0, $dTCkE.useState)({
        className: className,
        id: id,
        style: style
    });
    const [context, setContext] = (0, $dTCkE.useState)(null);
    (0, $dTCkE.useImperativeHandle)(forwardedRef, ()=>context?.map ?? null, [
        context
    ]);
    const mapRef = (0, $dTCkE.useCallback)((node)=>{
        if (node !== null && context === null) {
            const map = new (0, $80RSc.Map)(node, options);
            if (center != null && zoom != null) map.setView(center, zoom);
            else if (bounds != null) map.fitBounds(bounds, boundsOptions);
            if (whenReady != null) map.whenReady(whenReady);
            setContext((0, $7CNe0.createLeafletContext)(map));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $dTCkE.useEffect)(()=>{
        return ()=>{
            context?.map.remove();
        };
    }, [
        context
    ]);
    const contents = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dTCkE))).createElement((0, $7CNe0.LeafletProvider), {
        value: context
    }, children) : placeholder ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dTCkE))).createElement("div", $dce04b913d20622b$var$_extends({}, props, {
        ref: mapRef
    }), contents);
}
const $dce04b913d20622b$export$23f3dfd47374502b = /*#__PURE__*/ (0, $dTCkE.forwardRef)($dce04b913d20622b$var$MapContainerComponent);

});
parcelRegister("7CNe0", function(module, exports) {

$parcel$export(module.exports, "createLeafletContext", function () { return $58d24412ee0fe74b$export$fb237fa819e17281; });
$parcel$export(module.exports, "extendContext", function () { return $58d24412ee0fe74b$export$9efaf186a2224858; });
$parcel$export(module.exports, "LeafletProvider", function () { return $58d24412ee0fe74b$export$a24c9fc2f87814b2; });
$parcel$export(module.exports, "useLeafletContext", function () { return $58d24412ee0fe74b$export$ea59151b8430a4e9; });

var $dTCkE = parcelRequire("dTCkE");
const $58d24412ee0fe74b$export$b8efcc4bff45e15b = 1;
function $58d24412ee0fe74b$export$fb237fa819e17281(map) {
    return Object.freeze({
        __version: $58d24412ee0fe74b$export$b8efcc4bff45e15b,
        map: map
    });
}
function $58d24412ee0fe74b$export$9efaf186a2224858(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const $58d24412ee0fe74b$export$7de1b54b0142048f = (0, $dTCkE.createContext)(null);
const $58d24412ee0fe74b$export$a24c9fc2f87814b2 = $58d24412ee0fe74b$export$7de1b54b0142048f.Provider;
function $58d24412ee0fe74b$export$ea59151b8430a4e9() {
    const context = (0, $dTCkE.useContext)($58d24412ee0fe74b$export$7de1b54b0142048f);
    if (context == null) throw new Error("No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>");
    return context;
}

});


parcelRegister("k0QJm", function(module, exports) {

$parcel$export(module.exports, "Marker", function () { return $e91cb5edb9d3a689$export$e98856a975cab58e; });

var $jBLMJ = parcelRequire("jBLMJ");
var $hqBEw = parcelRequire("hqBEw");
var $7CNe0 = parcelRequire("7CNe0");

var $80RSc = parcelRequire("80RSc");
const $e91cb5edb9d3a689$export$e98856a975cab58e = (0, $hqBEw.createLayerComponent)(function createMarker({ position: position, ...options }, ctx) {
    const marker = new (0, $80RSc.Marker)(position, options);
    return (0, $jBLMJ.createElementObject)(marker, (0, $7CNe0.extendContext)(ctx, {
        overlayContainer: marker
    }));
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) marker.setLatLng(props.position);
    if (props.icon != null && props.icon !== prevProps.icon) marker.setIcon(props.icon);
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) marker.setZIndexOffset(props.zIndexOffset);
    if (props.opacity != null && props.opacity !== prevProps.opacity) marker.setOpacity(props.opacity);
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) marker.dragging.enable();
        else marker.dragging.disable();
    }
});

});
parcelRegister("jBLMJ", function(module, exports) {

$parcel$export(module.exports, "createElementObject", function () { return $e4668a1ee69a2c2b$export$a080ff44e8067a44; });
$parcel$export(module.exports, "createElementHook", function () { return $e4668a1ee69a2c2b$export$2e66ec8a7fb1892f; });

var $dTCkE = parcelRequire("dTCkE");
function $e4668a1ee69a2c2b$export$a080ff44e8067a44(instance, context, container) {
    return Object.freeze({
        instance: instance,
        context: context,
        container: container
    });
}
function $e4668a1ee69a2c2b$export$2e66ec8a7fb1892f(createElement, updateElement) {
    if (updateElement == null) return function useImmutableLeafletElement(props, context) {
        const elementRef = (0, $dTCkE.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        return elementRef;
    };
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0, $dTCkE.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        const propsRef = (0, $dTCkE.useRef)(props);
        const { instance: instance } = elementRef.current;
        (0, $dTCkE.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            context
        ]);
        return elementRef;
    };
}

});

parcelRegister("hqBEw", function(module, exports) {

$parcel$export(module.exports, "createLayerComponent", function () { return $cb02125ecbd77ac0$export$8a4d5778bce4c3ac; });
$parcel$export(module.exports, "createOverlayComponent", function () { return $cb02125ecbd77ac0$export$7d18e209be943d7d; });
$parcel$export(module.exports, "createPathComponent", function () { return $cb02125ecbd77ac0$export$5e776dbe3c7d2790; });
$parcel$export(module.exports, "createTileLayerComponent", function () { return $cb02125ecbd77ac0$export$4f432c6de5c4ddb8; });

var $a7R77 = parcelRequire("a7R77");

var $gWETh = parcelRequire("gWETh");

var $jBLMJ = parcelRequire("jBLMJ");

var $2XQfe = parcelRequire("2XQfe");

var $4LS70 = parcelRequire("4LS70");

var $3TCrZ = parcelRequire("3TCrZ");
function $cb02125ecbd77ac0$export$896a3ef451e396c4(createInstance) {
    function createElement(props, context) {
        return (0, $jBLMJ.createElementObject)(createInstance(props), context);
    }
    const useElement = (0, $jBLMJ.createElementHook)(createElement);
    const useControl = (0, $gWETh.createControlHook)(useElement);
    return (0, $a7R77.createLeafComponent)(useControl);
}
function $cb02125ecbd77ac0$export$8a4d5778bce4c3ac(createElement, updateElement) {
    const useElement = (0, $jBLMJ.createElementHook)(createElement, updateElement);
    const useLayer = (0, $2XQfe.createLayerHook)(useElement);
    return (0, $a7R77.createContainerComponent)(useLayer);
}
function $cb02125ecbd77ac0$export$7d18e209be943d7d(createElement, useLifecycle) {
    const useElement = (0, $jBLMJ.createElementHook)(createElement);
    const useOverlay = (0, $4LS70.createDivOverlayHook)(useElement, useLifecycle);
    return (0, $a7R77.createDivOverlayComponent)(useOverlay);
}
function $cb02125ecbd77ac0$export$5e776dbe3c7d2790(createElement, updateElement) {
    const useElement = (0, $jBLMJ.createElementHook)(createElement, updateElement);
    const usePath = (0, $3TCrZ.createPathHook)(useElement);
    return (0, $a7R77.createContainerComponent)(usePath);
}
function $cb02125ecbd77ac0$export$4f432c6de5c4ddb8(createElement, updateElement) {
    const useElement = (0, $jBLMJ.createElementHook)(createElement, updateElement);
    const useLayer = (0, $2XQfe.createLayerHook)(useElement);
    return (0, $a7R77.createLeafComponent)(useLayer);
}

});
parcelRegister("a7R77", function(module, exports) {

$parcel$export(module.exports, "createContainerComponent", function () { return $75f3c21f9cfee725$export$96eac748c3f41e82; });
$parcel$export(module.exports, "createDivOverlayComponent", function () { return $75f3c21f9cfee725$export$bc37ddc24ed05446; });
$parcel$export(module.exports, "createLeafComponent", function () { return $75f3c21f9cfee725$export$18af5c7a9e9b3664; });

var $dTCkE = parcelRequire("dTCkE");

var $7AkDt = parcelRequire("7AkDt");

var $7CNe0 = parcelRequire("7CNe0");
function $75f3c21f9cfee725$export$96eac748c3f41e82(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance: instance, context: context } = useElement(props).current;
        (0, $dTCkE.useImperativeHandle)(forwardedRef, ()=>instance);
        return props.children == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dTCkE))).createElement((0, $7CNe0.LeafletProvider), {
            value: context
        }, props.children);
    }
    return /*#__PURE__*/ (0, $dTCkE.forwardRef)(ContainerComponent);
}
function $75f3c21f9cfee725$export$bc37ddc24ed05446(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = (0, $dTCkE.useState)(false);
        const { instance: instance } = useElement(props, setOpen).current;
        (0, $dTCkE.useImperativeHandle)(forwardedRef, ()=>instance);
        (0, $dTCkE.useEffect)(function updateOverlay() {
            if (isOpen) instance.update();
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0, $7AkDt.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0, $dTCkE.forwardRef)(OverlayComponent);
}
function $75f3c21f9cfee725$export$18af5c7a9e9b3664(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance: instance } = useElement(props).current;
        (0, $dTCkE.useImperativeHandle)(forwardedRef, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0, $dTCkE.forwardRef)(LeafComponent);
}

});

parcelRegister("gWETh", function(module, exports) {

$parcel$export(module.exports, "createControlHook", function () { return $c561c827e6263c3d$export$28d24ab3914549cd; });

var $dTCkE = parcelRequire("dTCkE");

var $7CNe0 = parcelRequire("7CNe0");
function $c561c827e6263c3d$export$28d24ab3914549cd(useElement) {
    return function useLeafletControl(props) {
        const context = (0, $7CNe0.useLeafletContext)();
        const elementRef = useElement(props, context);
        const { instance: instance } = elementRef.current;
        const positionRef = (0, $dTCkE.useRef)(props.position);
        const { position: position } = props;
        (0, $dTCkE.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0, $dTCkE.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}

});

parcelRegister("2XQfe", function(module, exports) {

$parcel$export(module.exports, "useLayerLifecycle", function () { return $22899e24d0eb1815$export$cd00a227f8cfb2c2; });
$parcel$export(module.exports, "createLayerHook", function () { return $22899e24d0eb1815$export$73f852c6a5abdefa; });

var $dTCkE = parcelRequire("dTCkE");

var $JZaz1 = parcelRequire("JZaz1");

var $7CNe0 = parcelRequire("7CNe0");

var $hQNKW = parcelRequire("hQNKW");

var $93cdh = parcelRequire("93cdh");
function $22899e24d0eb1815$export$cd00a227f8cfb2c2(element, context) {
    (0, $dTCkE.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            context.layerContainer?.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function $22899e24d0eb1815$export$73f852c6a5abdefa(useElement) {
    return function useLayer(props) {
        const context = (0, $7CNe0.useLeafletContext)();
        const elementRef = useElement((0, $93cdh.withPane)(props, context), context);
        (0, $JZaz1.useAttribution)(context.map, props.attribution);
        (0, $hQNKW.useEventHandlers)(elementRef.current, props.eventHandlers);
        $22899e24d0eb1815$export$cd00a227f8cfb2c2(elementRef.current, context);
        return elementRef;
    };
}

});
parcelRegister("JZaz1", function(module, exports) {

$parcel$export(module.exports, "useAttribution", function () { return $08a3a70cca52bd4b$export$46b870813daca3d4; });

var $dTCkE = parcelRequire("dTCkE");
function $08a3a70cca52bd4b$export$46b870813daca3d4(map, attribution) {
    const attributionRef = (0, $dTCkE.useRef)(attribution);
    (0, $dTCkE.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) map.attributionControl.removeAttribution(attributionRef.current);
            if (attribution != null) map.attributionControl.addAttribution(attribution);
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}

});

parcelRegister("hQNKW", function(module, exports) {

$parcel$export(module.exports, "useEventHandlers", function () { return $cfede38517ff93bf$export$8ce912bc34d0dbea; });

var $dTCkE = parcelRequire("dTCkE");
function $cfede38517ff93bf$export$8ce912bc34d0dbea(element, eventHandlers) {
    const eventHandlersRef = (0, $dTCkE.useRef)();
    (0, $dTCkE.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) element.instance.on(eventHandlers);
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) element.instance.off(eventHandlersRef.current);
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}

});

parcelRegister("93cdh", function(module, exports) {

$parcel$export(module.exports, "withPane", function () { return $696dde276a4c842f$export$6ee5d263358f5c0e; });
function $696dde276a4c842f$export$6ee5d263358f5c0e(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane: pane
    } : props;
}

});


parcelRegister("4LS70", function(module, exports) {

$parcel$export(module.exports, "createDivOverlayHook", function () { return $379586b8c5cfdb43$export$d5eca53b0accc0e0; });

var $JZaz1 = parcelRequire("JZaz1");

var $7CNe0 = parcelRequire("7CNe0");

var $hQNKW = parcelRequire("hQNKW");

var $93cdh = parcelRequire("93cdh");
function $379586b8c5cfdb43$export$d5eca53b0accc0e0(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0, $7CNe0.useLeafletContext)();
        const elementRef = useElement((0, $93cdh.withPane)(props, context), context);
        (0, $JZaz1.useAttribution)(context.map, props.attribution);
        (0, $hQNKW.useEventHandlers)(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}

});

parcelRegister("3TCrZ", function(module, exports) {

$parcel$export(module.exports, "createPathHook", function () { return $2d645598cdb1c35e$export$5fea2fe6048fc3db; });

var $dTCkE = parcelRequire("dTCkE");

var $7CNe0 = parcelRequire("7CNe0");

var $hQNKW = parcelRequire("hQNKW");

var $2XQfe = parcelRequire("2XQfe");

var $93cdh = parcelRequire("93cdh");
function $2d645598cdb1c35e$export$d0296329a1f118ca(element, props) {
    const optionsRef = (0, $dTCkE.useRef)();
    (0, $dTCkE.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            const options = props.pathOptions ?? {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function $2d645598cdb1c35e$export$5fea2fe6048fc3db(useElement) {
    return function usePath(props) {
        const context = (0, $7CNe0.useLeafletContext)();
        const elementRef = useElement((0, $93cdh.withPane)(props, context), context);
        (0, $hQNKW.useEventHandlers)(elementRef.current, props.eventHandlers);
        (0, $2XQfe.useLayerLifecycle)(elementRef.current, context);
        $2d645598cdb1c35e$export$d0296329a1f118ca(elementRef.current, props);
        return elementRef;
    };
}

});



parcelRegister("kv2k9", function(module, exports) {

$parcel$export(module.exports, "TileLayer", function () { return $eec88165d8309f55$export$f52ee31d61d0b27b; });

var $jBLMJ = parcelRequire("jBLMJ");
var $hqBEw = parcelRequire("hqBEw");
var $3Ulpg = parcelRequire("3Ulpg");
var $93cdh = parcelRequire("93cdh");

var $80RSc = parcelRequire("80RSc");
const $eec88165d8309f55$export$f52ee31d61d0b27b = (0, $hqBEw.createTileLayerComponent)(function createTileLayer({ url: url, ...options }, context) {
    const layer = new (0, $80RSc.TileLayer)(url, (0, $93cdh.withPane)(options, context));
    return (0, $jBLMJ.createElementObject)(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    (0, $3Ulpg.updateGridLayer)(layer, props, prevProps);
    const { url: url } = props;
    if (url != null && url !== prevProps.url) layer.setUrl(url);
});

});
parcelRegister("3Ulpg", function(module, exports) {

$parcel$export(module.exports, "updateGridLayer", function () { return $2d8734ed67311907$export$b39104a5f1b9296f; });
function $2d8734ed67311907$export$b39104a5f1b9296f(layer, props, prevProps) {
    const { opacity: opacity, zIndex: zIndex } = props;
    if (opacity != null && opacity !== prevProps.opacity) layer.setOpacity(opacity);
    if (zIndex != null && zIndex !== prevProps.zIndex) layer.setZIndex(zIndex);
}

});


parcelRegister("55GGo", function(module, exports) {
!function(a, t) {
    t(module.exports);
}(module.exports, function(a) {
    "use strict";
    var o = {
        ar: {
            touch: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0625\u0635\u0628\u0639\u064A\u0646 \u0644\u062A\u062D\u0631\u064A\u0643 \u0627\u0644\u062E\u0631\u064A\u0637\u0629",
            scroll: "\u200F\u0627\u0633\u062A\u062E\u062F\u0645 ctrl + scroll \u0644\u062A\u0635\u063A\u064A\u0631/\u062A\u0643\u0628\u064A\u0631 \u0627\u0644\u062E\u0631\u064A\u0637\u0629",
            scrollMac: "\u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u2318 + \u0627\u0644\u062A\u0645\u0631\u064A\u0631 \u0644\u062A\u0643\u0628\u064A\u0631/\u062A\u0635\u063A\u064A\u0631 \u0627\u0644\u062E\u0631\u064A\u0637\u0629"
        },
        bg: {
            touch: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u0434\u0432\u0430 \u043F\u0440\u044A\u0441\u0442\u0430, \u0437\u0430 \u0434\u0430 \u043F\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u0435 \u043A\u0430\u0440\u0442\u0430\u0442\u0430",
            scroll: "\u0417\u0430\u0434\u0440\u044A\u0436\u0442\u0435 \u0431\u0443\u0442\u043E\u043D\u0430 Ctrl \u043D\u0430\u0442\u0438\u0441\u043D\u0430\u0442, \u0434\u043E\u043A\u0430\u0442\u043E \u043F\u0440\u0435\u0432\u044A\u0440\u0442\u0430\u0442\u0435, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435 \u043C\u0430\u0449\u0430\u0431\u0430 \u043D\u0430 \u043A\u0430\u0440\u0442\u0430\u0442\u0430",
            scrollMac: "\u0417\u0430\u0434\u0440\u044A\u0436\u0442\u0435 \u0431\u0443\u0442\u043E\u043D\u0430 \u2318 \u043D\u0430\u0442\u0438\u0441\u043D\u0430\u0442, \u0434\u043E\u043A\u0430\u0442\u043E \u043F\u0440\u0435\u0432\u044A\u0440\u0442\u0430\u0442\u0435, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435 \u043C\u0430\u0449\u0430\u0431\u0430 \u043D\u0430 \u043A\u0430\u0440\u0442\u0430\u0442\u0430"
        },
        bn: {
            touch: "\u09AE\u09BE\u09A8\u099A\u09BF\u09A4\u09CD\u09B0\u099F\u09BF\u0995\u09C7 \u09B8\u09B0\u09BE\u09A4\u09C7 \u09A6\u09C1\u099F\u09BF \u0986\u0999\u09CD\u0997\u09C1\u09B2 \u09AC\u09CD\u09AF\u09AC\u09B9\u09BE\u09B0 \u0995\u09B0\u09C1\u09A8",
            scroll: "\u09AE\u09CD\u09AF\u09BE\u09AA \u099C\u09C1\u09AE \u0995\u09B0\u09A4\u09C7 ctrl + scroll \u09AC\u09CD\u09AF\u09AC\u09B9\u09BE\u09B0 \u0995\u09B0\u09C1\u09A8",
            scrollMac: "\u09AE\u09CD\u09AF\u09BE\u09AA\u09C7 \u099C\u09C1\u09AE \u0995\u09B0\u09A4\u09C7 \u2318 \u09AC\u09CB\u09A4\u09BE\u09AE \u099F\u09BF\u09AA\u09C7 \u09B8\u09CD\u0995\u09CD\u09B0\u09B2 \u0995\u09B0\u09C1\u09A8"
        },
        ca: {
            touch: "Fes servir dos dits per moure el mapa",
            scroll: "Prem la tecla Control mentre et desplaces per apropar i allunyar el mapa",
            scrollMac: "Prem la tecla \u2318 mentre et desplaces per apropar i allunyar el mapa"
        },
        cs: {
            touch: "K\xa0posunut\xed mapy pou\u017Eijte dva prsty",
            scroll: "Velikost zobrazen\xed mapy zm\u011B\u0148te podr\u017Een\xedm kl\xe1vesy Ctrl a\xa0posouv\xe1n\xedm kole\u010Dka my\u0161i",
            scrollMac: "Velikost zobrazen\xed mapy zm\u011Bn\xedte podr\u017Een\xedm kl\xe1vesy \u2318 a\xa0posunut\xedm kole\u010Dka my\u0161i / touchpadu"
        },
        da: {
            touch: "Brug to fingre til at flytte kortet",
            scroll: "Brug ctrl + rullefunktionen til at zoome ind og ud p\xe5 kortet",
            scrollMac: "Brug \u2318 + rullefunktionen til at zoome ind og ud p\xe5 kortet"
        },
        de: {
            touch: "Verschieben der Karte mit zwei Fingern",
            scroll: "Verwende Strg+Scrollen zum Zoomen der Karte",
            scrollMac: "\u2318"
        },
        el: {
            touch: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03B4\u03CD\u03BF \u03B4\u03AC\u03C7\u03C4\u03C5\u03BB\u03B1 \u03B3\u03B9\u03B1 \u03BC\u03B5\u03C4\u03B1\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7",
            scroll: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BB\u03AE\u03BA\u03C4\u03C1\u03BF Ctrl \u03BA\u03B1\u03B9 \u03BA\u03CD\u03BB\u03B9\u03C3\u03B7, \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BC\u03B5\u03B3\u03B5\u03B8\u03CD\u03BD\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7",
            scrollMac: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BB\u03AE\u03BA\u03C4\u03C1\u03BF \u2318 + \u03BA\u03CD\u03BB\u03B9\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03B5\u03C3\u03C4\u03AF\u03B1\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7"
        },
        en: {
            touch: "Use two fingers to move the map",
            scroll: "Use ctrl + scroll to zoom the map",
            scrollMac: "Use \u2318 + scroll to zoom the map"
        },
        "en-AU": {
            touch: "Use two fingers to move the map",
            scroll: "Use ctrl + scroll to zoom the map",
            scrollMac: "Use \u2318 + scroll to zoom the map"
        },
        "en-GB": {
            touch: "Use two fingers to move the map",
            scroll: "Use ctrl + scroll to zoom the map",
            scrollMac: "Use \u2318 + scroll to zoom the map"
        },
        es: {
            touch: "Para mover el mapa, utiliza dos dedos",
            scroll: "Mant\xe9n pulsada la tecla Ctrl mientras te desplazas para acercar o alejar el mapa",
            scrollMac: "Mant\xe9n pulsada la tecla \u2318 mientras te desplazas para acercar o alejar el mapa"
        },
        eu: {
            touch: "Erabili bi hatz mapa mugitzeko",
            scroll: "Mapan zooma aplikatzeko, sakatu Ktrl eta egin gora edo behera",
            scrollMac: "Eduki sakatuta \u2318 eta egin gora eta behera mapa handitu eta txikitzeko"
        },
        fa: {
            touch: "\u0628\u0631\u0627\u06CC \u062D\u0631\u06A9\u062A \u062F\u0627\u062F\u0646 \u0646\u0642\u0634\u0647 \u0627\u0632 \u062F\u0648 \u0627\u0646\u06AF\u0634\u062A \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0646\u06CC\u062F.",
            scroll: "\u200F\u0628\u0631\u0627\u06CC \u0628\u0632\u0631\u06AF\u200C\u0646\u0645\u0627\u06CC\u06CC \u0646\u0642\u0634\u0647 \u0627\u0632 ctrl + scroll \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0646\u06CC\u062F",
            scrollMac: "\u0628\u0631\u0627\u06CC \u0628\u0632\u0631\u06AF\u200C\u0646\u0645\u0627\u06CC\u06CC \u0646\u0642\u0634\u0647\u060C \u0627\u0632 \u2318 + \u067E\u06CC\u0645\u0627\u06CC\u0634 \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0646\u06CC\u062F."
        },
        fi: {
            touch: "Siirr\xe4 karttaa kahdella sormella.",
            scroll: "Zoomaa karttaa painamalla Ctrl-painiketta ja vieritt\xe4m\xe4ll\xe4.",
            scrollMac: "Zoomaa karttaa pit\xe4m\xe4ll\xe4 painike \u2318 painettuna ja vieritt\xe4m\xe4ll\xe4."
        },
        fil: {
            touch: "Gumamit ng dalawang daliri upang iusog ang mapa",
            scroll: "Gamitin ang ctrl + scroll upang i-zoom ang mapa",
            scrollMac: "Gamitin ang \u2318 + scroll upang i-zoom ang mapa"
        },
        fr: {
            touch: "Utilisez deux\xa0doigts pour d\xe9placer la carte",
            scroll: "Vous pouvez zoomer sur la carte \xe0 l'aide de CTRL+Molette de d\xe9filement",
            scrollMac: "Vous pouvez zoomer sur la carte \xe0 l'aide de \u2318+Molette de d\xe9filement"
        },
        gl: {
            touch: "Utiliza dous dedos para mover o mapa",
            scroll: "Preme Ctrl mentres te desprazas para ampliar o mapa",
            scrollMac: "Preme \u2318 e despr\xe1zate para ampliar o mapa"
        },
        gu: {
            touch: "\u0AA8\u0A95\u0AB6\u0ACB \u0A96\u0AB8\u0AC7\u0AA1\u0AB5\u0ABE \u0AAC\u0AC7 \u0A86\u0A82\u0A97\u0AB3\u0AC0\u0A93\u0AA8\u0ACB \u0A89\u0AAA\u0AAF\u0ACB\u0A97 \u0A95\u0AB0\u0ACB",
            scroll: "\u0AA8\u0A95\u0AB6\u0ABE\u0AA8\u0AC7 \u0A9D\u0AC2\u0AAE \u0A95\u0AB0\u0AB5\u0ABE \u0AAE\u0ABE\u0A9F\u0AC7 ctrl + \u0AB8\u0ACD\u0A95\u0ACD\u0AB0\u0ACB\u0AB2\u0AA8\u0ACB \u0A89\u0AAA\u0AAF\u0ACB\u0A97 \u0A95\u0AB0\u0ACB",
            scrollMac: "\u0AA8\u0A95\u0AB6\u0ABE\u0AA8\u0AC7 \u0A9D\u0AC2\u0AAE \u0A95\u0AB0\u0AB5\u0ABE \u2318 + \u0AB8\u0ACD\u0A95\u0ACD\u0AB0\u0ACB\u0AB2\u0AA8\u0ACB \u0A89\u0AAA\u0AAF\u0ACB\u0A97 \u0A95\u0AB0\u0ACB"
        },
        hi: {
            touch: "\u092E\u0948\u092A \u090F\u0915 \u091C\u0917\u0939 \u0938\u0947 \u0926\u0942\u0938\u0930\u0940 \u091C\u0917\u0939 \u0932\u0947 \u091C\u093E\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0926\u094B \u0909\u0902\u0917\u0932\u093F\u092F\u094B\u0902 \u0915\u093E \u0907\u0938\u094D\u0924\u0947\u092E\u093E\u0932 \u0915\u0930\u0947\u0902",
            scroll: "\u092E\u0948\u092A \u0915\u094B \u091C\u093C\u0942\u092E \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F ctrl + \u0938\u094D\u0915\u094D\u0930\u094B\u0932 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0947\u0902",
            scrollMac: "\u092E\u0948\u092A \u0915\u094B \u091C\u093C\u0942\u092E \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u2318 + \u0938\u094D\u0915\u094D\u0930\u094B\u0932 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0947\u0902"
        },
        hr: {
            touch: "Pomi\u010Dite kartu pomo\u0107u dva prsta",
            scroll: "Upotrijebite Ctrl i kliza\u010D mi\u0161a da biste zumirali kartu",
            scrollMac: "Upotrijebite gumb \u2318 dok se pomi\u010Dete za zumiranje karte"
        },
        hu: {
            touch: "K\xe9t ujjal mozgassa a t\xe9rk\xe9pet",
            scroll: "A t\xe9rk\xe9p a ctrl + g\xf6rget\xe9s haszn\xe1lat\xe1val nagy\xedthat\xf3",
            scrollMac: "A t\xe9rk\xe9p a \u2318 + g\xf6rget\xe9s haszn\xe1lat\xe1val nagy\xedthat\xf3"
        },
        id: {
            touch: "Gunakan dua jari untuk menggerakkan peta",
            scroll: "Gunakan ctrl + scroll untuk memperbesar atau memperkecil peta",
            scrollMac: "Gunakan \u2318 + scroll untuk memperbesar atau memperkecil peta"
        },
        it: {
            touch: "Utilizza due dita per spostare la mappa",
            scroll: "Utilizza CTRL + scorrimento per eseguire lo zoom della mappa",
            scrollMac: "Utilizza \u2318 + scorrimento per eseguire lo zoom della mappa"
        },
        iw: {
            touch: "\u05D4\u05D6\u05D6 \u05D0\u05EA \u05D4\u05DE\u05E4\u05D4 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05E9\u05EA\u05D9 \u05D0\u05E6\u05D1\u05E2\u05D5\u05EA",
            scroll: "\u200F\u05D0\u05E4\u05E9\u05E8 \u05DC\u05E9\u05E0\u05D5\u05EA \u05D0\u05EA \u05DE\u05E8\u05D7\u05E7 \u05D4\u05EA\u05E6\u05D5\u05D2\u05D4 \u05D1\u05DE\u05E4\u05D4 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05DE\u05E7\u05E9 ctrl \u05D5\u05D2\u05DC\u05D9\u05DC\u05D4",
            scrollMac: "\u05D0\u05E4\u05E9\u05E8 \u05DC\u05E9\u05E0\u05D5\u05EA \u05D0\u05EA \u05DE\u05E8\u05D7\u05E7 \u05D4\u05EA\u05E6\u05D5\u05D2\u05D4 \u05D1\u05DE\u05E4\u05D4 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05DE\u05E7\u05E9 \u2318 \u05D5\u05D2\u05DC\u05D9\u05DC\u05D4"
        },
        ja: {
            touch: "\u5730\u56F3\u3092\u79FB\u52D5\u3055\u305B\u308B\u306B\u306F\u6307 2 \u672C\u3067\u64CD\u4F5C\u3057\u307E\u3059",
            scroll: "\u5730\u56F3\u3092\u30BA\u30FC\u30E0\u3059\u308B\u306B\u306F\u3001Ctrl \u30AD\u30FC\u3092\u62BC\u3057\u306A\u304C\u3089\u30B9\u30AF\u30ED\u30FC\u30EB\u3057\u3066\u304F\u3060\u3055\u3044",
            scrollMac: "\u5730\u56F3\u3092\u30BA\u30FC\u30E0\u3059\u308B\u306B\u306F\u3001\u2318 \u30AD\u30FC\u3092\u62BC\u3057\u306A\u304C\u3089\u30B9\u30AF\u30ED\u30FC\u30EB\u3057\u3066\u304F\u3060\u3055\u3044"
        },
        kn: {
            touch: "Use two fingers to move the map",
            scroll: "Use Ctrl + scroll to zoom the map",
            scrollMac: "Use \u2318 + scroll to zoom the map"
        },
        ko: {
            touch: "\uC9C0\uB3C4\uB97C \uC6C0\uC9C1\uC774\uB824\uBA74 \uB450 \uC190\uAC00\uB77D\uC744 \uC0AC\uC6A9\uD558\uC138\uC694.",
            scroll: "\uC9C0\uB3C4\uB97C \uD655\uB300/\uCD95\uC18C\uD558\uB824\uBA74 Ctrl\uC744 \uB204\uB978 \uCC44 \uC2A4\uD06C\uB864\uD558\uC138\uC694.",
            scrollMac: "\uC9C0\uB3C4\uB97C \uD655\uB300\uD558\uB824\uBA74 \u2318 + \uC2A4\uD06C\uB864 \uC0AC\uC6A9"
        },
        lt: {
            touch: "Perkelkite \u017Eem\u0117lap\u012F dviem pir\u0161tais",
            scroll: "Slinkite nuspaud\u0119 klavi\u0161\u0105 \u201ECtrl\u201C, kad pakeistum\u0117te \u017Eem\u0117lapio mastel\u012F",
            scrollMac: "Paspauskite klavi\u0161\u0105 \u2318 ir slinkite, kad priartintum\u0117te \u017Eem\u0117lap\u012F"
        },
        lv: {
            touch: "Lai p\u0101rvietotu karti, b\u012Bdiet to ar diviem pirkstiem",
            scroll: "Kartes t\u0101lummai\u0146ai izmantojiet ctrl + ritin\u0101\u0161anu",
            scrollMac: "Lai veiktu kartes t\u0101lummai\u0146u, izmantojiet \u2318 + ritin\u0101\u0161anu"
        },
        ml: {
            touch: "\u0D2E\u0D3E\u0D2A\u0D4D\u0D2A\u0D4D \u0D28\u0D40\u0D15\u0D4D\u0D15\u0D3E\u0D7B \u0D30\u0D23\u0D4D\u0D1F\u0D4D \u0D35\u0D3F\u0D30\u0D32\u0D41\u0D15\u0D7E \u0D09\u0D2A\u0D2F\u0D4B\u0D17\u0D3F\u0D15\u0D4D\u0D15\u0D41\u0D15",
            scroll: "\u0D15\u0D7A\u0D1F\u0D4D\u0D30\u0D4B\u0D7E + \u0D38\u0D4D\u200C\u0D15\u0D4D\u0D30\u0D4B\u0D7E \u0D09\u0D2A\u0D2F\u0D4B\u0D17\u0D3F\u0D1A\u0D4D\u0D1A\u0D4D \u200C\u0D2E\u0D3E\u0D2A\u0D4D\u0D2A\u0D4D \u200C\u0D38\u0D42\u0D02 \u0D1A\u0D46\u0D2F\u0D4D\u0D2F\u0D41\u0D15",
            scrollMac: "\u2318 + \u0D38\u0D4D\u200C\u0D15\u0D4D\u0D30\u0D4B\u0D7E \u0D09\u0D2A\u0D2F\u0D4B\u0D17\u0D3F\u0D1A\u0D4D\u0D1A\u0D4D \u200C\u0D2E\u0D3E\u0D2A\u0D4D\u0D2A\u0D4D \u200C\u0D38\u0D42\u0D02 \u0D1A\u0D46\u0D2F\u0D4D\u0D2F\u0D41\u0D15"
        },
        mr: {
            touch: "\u0928\u0915\u093E\u0936\u093E \u0939\u0932\u0935\u093F\u0923\u094D\u092F\u093E\u0938\u093E\u0920\u0940 \u0926\u094B\u0928 \u092C\u094B\u091F\u0947 \u0935\u093E\u092A\u0930\u093E",
            scroll: "\u0928\u0915\u093E\u0936\u093E \u091D\u0942\u092E \u0915\u0930\u0923\u094D\u092F\u093E\u0938\u093E\u0920\u0940 ctrl + scroll \u0935\u093E\u092A\u0930\u093E",
            scrollMac: "\u0928\u0915\u093E\u0936\u093E\u0935\u0930 \u091D\u0942\u092E \u0915\u0930\u0923\u094D\u092F\u093E\u0938\u093E\u0920\u0940 \u2318 + \u0938\u094D\u0915\u094D\u0930\u094B\u0932 \u0935\u093E\u092A\u0930\u093E"
        },
        nl: {
            touch: "Gebruik twee vingers om de kaart te verplaatsen",
            scroll: "Gebruik Ctrl + scrollen om in- en uit te zoomen op de kaart",
            scrollMac: "Gebruik \u2318 + scrollen om in en uit te zoomen op de kaart"
        },
        no: {
            touch: "Bruk to fingre for \xe5 flytte kartet",
            scroll: "Hold ctrl-tasten inne og rull for \xe5 zoome p\xe5 kartet",
            scrollMac: "Hold inne \u2318-tasten og rull for \xe5 zoome p\xe5 kartet"
        },
        pl: {
            touch: "Przesu\u0144 map\u0119 dwoma palcami",
            scroll: "Naci\u015Bnij CTRL i przewi\u0144, by przybli\u017Cy\u0107 map\u0119",
            scrollMac: "Naci\u015Bnij\xa0\u2318 i przewi\u0144, by przybli\u017Cy\u0107 map\u0119"
        },
        pt: {
            touch: "Use dois dedos para mover o mapa",
            scroll: "Pressione Ctrl e role a tela simultaneamente para aplicar zoom no mapa",
            scrollMac: "Use \u2318 e role a tela simultaneamente para aplicar zoom no mapa"
        },
        "pt-BR": {
            touch: "Use dois dedos para mover o mapa",
            scroll: "Pressione Ctrl e role a tela simultaneamente para aplicar zoom no mapa",
            scrollMac: "Use \u2318 e role a tela simultaneamente para aplicar zoom no mapa"
        },
        "pt-PT": {
            touch: "Utilize dois dedos para mover o mapa",
            scroll: "Utilizar ctrl + deslocar para aumentar/diminuir zoom do mapa",
            scrollMac: "Utilize \u2318 + deslocar para aumentar/diminuir o zoom do mapa"
        },
        ro: {
            touch: "Folosi\u021Bi dou\u0103 degete pentru a deplasa harta",
            scroll: "Ap\u0103sa\u021Bi tasta ctrl \u0219i derula\u021Bi simultan pentru a m\u0103ri harta",
            scrollMac: "Folosi\u021Bi \u2318 \u0219i derula\u021Bi pentru a m\u0103ri/mic\u0219ora harta"
        },
        ru: {
            touch: "\u0427\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043A\u0430\u0440\u0442\u0443, \u043F\u0440\u043E\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E \u043D\u0435\u0439 \u0434\u0432\u0443\u043C\u044F \u043F\u0430\u043B\u044C\u0446\u0430\u043C\u0438",
            scroll: "\u0427\u0442\u043E\u0431\u044B \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043C\u0430\u0441\u0448\u0442\u0430\u0431, \u043F\u0440\u043E\u043A\u0440\u0443\u0447\u0438\u0432\u0430\u0439\u0442\u0435 \u043A\u0430\u0440\u0442\u0443, \u0443\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u044F \u043A\u043B\u0430\u0432\u0438\u0448\u0443 Ctrl.",
            scrollMac: "\u0427\u0442\u043E\u0431\u044B \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043C\u0430\u0441\u0448\u0442\u0430\u0431, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u2318\xa0+ \u043F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0430"
        },
        sk: {
            touch: "Mapu m\xf4\u017Eete posun\xfa\u0165 dvoma prstami",
            scroll: "Ak chcete pribl\xed\u017Ei\u0165 mapu, stla\u010Dte kl\xe1ves ctrl a\xa0pos\xfavajte",
            scrollMac: "Ak chcete pribl\xed\u017Ei\u0165 mapu, stla\u010Dte kl\xe1ves \u2318 a\xa0pos\xfavajte kolieskom my\u0161i"
        },
        sl: {
            touch: "Premaknite zemljevid z dvema prstoma",
            scroll: "Zemljevid pove\u010Date tako, da dr\u017Eite tipko Ctrl in vrtite kolesce na mi\u0161ki",
            scrollMac: "Uporabite \u2318 + funkcijo pomika, da pove\u010Date ali pomanj\u0161ate zemljevid"
        },
        sr: {
            touch: "\u041C\u0430\u043F\u0443 \u043F\u043E\u043C\u0435\u0440\u0430\u0458\u0442\u0435 \u043F\u043E\u043C\u043E\u045B\u0443 \u0434\u0432\u0430 \u043F\u0440\u0441\u0442\u0430",
            scroll: "\u041F\u0440\u0438\u0442\u0438\u0441\u043D\u0438\u0442\u0435 ctrl \u0442\u0430\u0441\u0442\u0435\u0440 \u0434\u043E\u043A \u043F\u043E\u043C\u0435\u0440\u0430\u0442\u0435 \u0434\u0430 \u0431\u0438\u0441\u0442\u0435 \u0437\u0443\u043C\u0438\u0440\u0430\u043B\u0438 \u043C\u0430\u043F\u0443",
            scrollMac: "\u041F\u0440\u0438\u0442\u0438\u0441\u043D\u0438\u0442\u0435 \u0442\u0430\u0441\u0442\u0435\u0440 \u2318 \u0434\u043E\u043A \u043F\u043E\u043C\u0435\u0440\u0430\u0442\u0435 \u0434\u0430 \u0431\u0438\u0441\u0442\u0435 \u0437\u0443\u043C\u0438\u0440\u0430\u043B\u0438 \u043C\u0430\u043F\u0443"
        },
        sv: {
            touch: "Anv\xe4nd tv\xe5 fingrar f\xf6r att flytta kartan",
            scroll: "Anv\xe4nd ctrl + rulla f\xf6r att zooma kartan",
            scrollMac: "Anv\xe4nd \u2318 + rulla f\xf6r att zooma p\xe5 kartan"
        },
        ta: {
            touch: "\u0BAE\u0BC7\u0BAA\u0BCD\u0BAA\u0BC8 \u0BA8\u0B95\u0BB0\u0BCD\u0BA4\u0BCD\u0BA4 \u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BC1 \u0BB5\u0BBF\u0BB0\u0BB2\u0BCD\u0B95\u0BB3\u0BC8\u0BAA\u0BCD \u0BAA\u0BAF\u0BA9\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BB5\u0BC1\u0BAE\u0BCD",
            scroll: "\u0BAE\u0BC7\u0BAA\u0BCD\u0BAA\u0BC8 \u0BAA\u0BC6\u0BB0\u0BBF\u0BA4\u0BBE\u0B95\u0BCD\u0B95\u0BBF/\u0B9A\u0BBF\u0BB1\u0BBF\u0BA4\u0BBE\u0B95\u0BCD\u0B95\u0BBF\u0BAA\u0BCD \u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95, ctrl \u0BAA\u0B9F\u0BCD\u0B9F\u0BA9\u0BC8\u0BAA\u0BCD \u0BAA\u0BBF\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BAA\u0B9F\u0BBF, \u0BAE\u0BC7\u0BB2\u0BC7/\u0B95\u0BC0\u0BB4\u0BC7 \u0BB8\u0BCD\u0B95\u0BCD\u0BB0\u0BBE\u0BB2\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BAF\u0BB5\u0BC1\u0BAE\u0BCD",
            scrollMac: "\u0BAE\u0BC7\u0BAA\u0BCD\u0BAA\u0BC8 \u0BAA\u0BC6\u0BB0\u0BBF\u0BA4\u0BBE\u0B95\u0BCD\u0B95\u0BBF/\u0B9A\u0BBF\u0BB1\u0BBF\u0BA4\u0BBE\u0B95\u0BCD\u0B95\u0BBF\u0BAA\u0BCD \u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95, \u2318 \u0BAA\u0B9F\u0BCD\u0B9F\u0BA9\u0BC8\u0BAA\u0BCD \u0BAA\u0BBF\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BAA\u0B9F\u0BBF, \u0BAE\u0BC7\u0BB2\u0BC7/\u0B95\u0BC0\u0BB4\u0BC7 \u0BB8\u0BCD\u0B95\u0BCD\u0BB0\u0BBE\u0BB2\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BAF\u0BB5\u0BC1\u0BAE\u0BCD"
        },
        te: {
            touch: "\u0C2E\u0C4D\u0C2F\u0C3E\u0C2A\u0C4D\u200C\u0C28\u0C3F \u0C24\u0C30\u0C32\u0C3F\u0C02\u0C1A\u0C21\u0C02 \u0C15\u0C4B\u0C38\u0C02 \u0C30\u0C46\u0C02\u0C21\u0C41 \u0C35\u0C47\u0C33\u0C4D\u0C32\u0C28\u0C41 \u0C09\u0C2A\u0C2F\u0C4B\u0C17\u0C3F\u0C02\u0C1A\u0C02\u0C21\u0C3F",
            scroll: "\u0C2E\u0C4D\u0C2F\u0C3E\u0C2A\u0C4D\u200C\u0C28\u0C3F \u0C1C\u0C42\u0C2E\u0C4D \u0C1A\u0C47\u0C2F\u0C21\u0C3E\u0C28\u0C3F\u0C15\u0C3F ctrl \u0C2C\u0C1F\u0C28\u0C4D\u200C\u0C28\u0C41 \u0C28\u0C4A\u0C15\u0C4D\u0C15\u0C3F \u0C09\u0C02\u0C1A\u0C3F, \u0C38\u0C4D\u0C15\u0C4D\u0C30\u0C4B\u0C32\u0C4D \u0C1A\u0C47\u0C2F\u0C02\u0C21\u0C3F",
            scrollMac: "\u0C2E\u0C4D\u0C2F\u0C3E\u0C2A\u0C4D \u0C1C\u0C42\u0C2E\u0C4D \u0C1A\u0C47\u0C2F\u0C3E\u0C32\u0C02\u0C1F\u0C47 \u2318 + \u0C38\u0C4D\u0C15\u0C4D\u0C30\u0C4B\u0C32\u0C4D \u0C09\u0C2A\u0C2F\u0C4B\u0C17\u0C3F\u0C02\u0C1A\u0C02\u0C21\u0C3F"
        },
        th: {
            touch: "\u0E43\u0E0A\u0E49 2 \u0E19\u0E34\u0E49\u0E27\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E41\u0E1C\u0E19\u0E17\u0E35\u0E48",
            scroll: "\u0E01\u0E14 Ctrl \u0E04\u0E49\u0E32\u0E07\u0E44\u0E27\u0E49 \u0E41\u0E25\u0E49\u0E27\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E0B\u0E39\u0E21\u0E41\u0E1C\u0E19\u0E17\u0E35\u0E48",
            scrollMac: "\u0E01\u0E14 \u2318 \u0E41\u0E25\u0E49\u0E27\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E0B\u0E39\u0E21\u0E41\u0E1C\u0E19\u0E17\u0E35\u0E48"
        },
        tl: {
            touch: "Gumamit ng dalawang daliri upang iusog ang mapa",
            scroll: "Gamitin ang ctrl + scroll upang i-zoom ang mapa",
            scrollMac: "Gamitin ang \u2318 + scroll upang i-zoom ang mapa"
        },
        tr: {
            touch: "Haritada gezinmek i\xe7in iki parma\u011F\u0131n\u0131z\u0131 kullan\u0131n",
            scroll: "Haritay\u0131 yak\u0131nla\u015Ft\u0131rmak i\xe7in ctrl + kayd\u0131rma kombinasyonunu kullan\u0131n",
            scrollMac: "Haritay\u0131 yak\u0131nla\u015Ft\u0131rmak i\xe7in \u2318 tu\u015Funa bas\u0131p ekran\u0131 kayd\u0131r\u0131n"
        },
        uk: {
            touch: "\u041F\u0435\u0440\u0435\u043C\u0456\u0449\u0443\u0439\u0442\u0435 \u043A\u0430\u0440\u0442\u0443 \u0434\u0432\u043E\u043C\u0430 \u043F\u0430\u043B\u044C\u0446\u044F\u043C\u0438",
            scroll: "\u0429\u043E\u0431 \u0437\u043C\u0456\u043D\u044E\u0432\u0430\u0442\u0438 \u043C\u0430\u0441\u0448\u0442\u0430\u0431 \u043A\u0430\u0440\u0442\u0438, \u043F\u0440\u043E\u043A\u0440\u0443\u0447\u0443\u0439\u0442\u0435 \u043A\u043E\u043B\u0456\u0449\u0430\u0442\u043A\u043E \u043C\u0438\u0448\u0456, \u0443\u0442\u0440\u0438\u043C\u0443\u044E\u0447\u0438 \u043A\u043B\u0430\u0432\u0456\u0448\u0443 Ctrl",
            scrollMac: "\u0429\u043E\u0431 \u0437\u043C\u0456\u043D\u0438\u0442\u0438 \u043C\u0430\u0441\u0448\u0442\u0430\u0431 \u043A\u0430\u0440\u0442\u0438, \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u2318 + \u043F\u0440\u043E\u043A\u0440\u0443\u0447\u0443\u0432\u0430\u043D\u043D\u044F"
        },
        vi: {
            touch: "S\u1EED d\u1EE5ng hai ng\xf3n tay \u0111\u1EC3 di chuy\u1EC3n b\u1EA3n \u0111\u1ED3",
            scroll: "S\u1EED d\u1EE5ng ctrl + cu\u1ED9n \u0111\u1EC3 thu ph\xf3ng b\u1EA3n \u0111\u1ED3",
            scrollMac: "S\u1EED d\u1EE5ng \u2318 + cu\u1ED9n \u0111\u1EC3 thu ph\xf3ng b\u1EA3n \u0111\u1ED3"
        },
        "zh-CN": {
            touch: "\u4F7F\u7528\u53CC\u6307\u79FB\u52A8\u5730\u56FE",
            scroll: "\u6309\u4F4F Ctrl \u5E76\u6EDA\u52A8\u9F20\u6807\u6EDA\u8F6E\u624D\u53EF\u7F29\u653E\u5730\u56FE",
            scrollMac: "\u6309\u4F4F \u2318 \u5E76\u6EDA\u52A8\u9F20\u6807\u6EDA\u8F6E\u624D\u53EF\u7F29\u653E\u5730\u56FE"
        },
        "zh-TW": {
            touch: "\u540C\u6642\u4EE5\u5169\u6307\u79FB\u52D5\u5730\u5716",
            scroll: "\u6309\u4F4F ctrl \u9375\u52A0\u4E0A\u6372\u52D5\u6ED1\u9F20\u53EF\u4EE5\u7E2E\u653E\u5730\u5716",
            scrollMac: "\u6309 \u2318 \u52A0\u4E0A\u6EFE\u52D5\u6372\u8EF8\u53EF\u4EE5\u7E2E\u653E\u5730\u5716"
        }
    };
    L.Map.mergeOptions({
        gestureHandlingOptions: {
            text: {},
            duration: 1e3
        }
    });
    var t = !1, e = L.Handler.extend({
        addHooks: function() {
            this._handleTouch = this._handleTouch.bind(this), this._setupPluginOptions(), this._setLanguageContent(), this._disableInteractions(), this._map._container.addEventListener("touchstart", this._handleTouch), this._map._container.addEventListener("touchmove", this._handleTouch), this._map._container.addEventListener("touchend", this._handleTouch), this._map._container.addEventListener("touchcancel", this._handleTouch), this._map._container.addEventListener("click", this._handleTouch), L.DomEvent.on(this._map._container, "wheel", this._handleScroll, this), L.DomEvent.on(this._map, "mouseover", this._handleMouseOver, this), L.DomEvent.on(this._map, "mouseout", this._handleMouseOut, this), L.DomEvent.on(this._map, "movestart", this._handleDragging, this), L.DomEvent.on(this._map, "move", this._handleDragging, this), L.DomEvent.on(this._map, "moveend", this._handleDragging, this);
        },
        removeHooks: function() {
            this._enableInteractions(), this._map._container.removeEventListener("touchstart", this._handleTouch), this._map._container.removeEventListener("touchmove", this._handleTouch), this._map._container.removeEventListener("touchend", this._handleTouch), this._map._container.removeEventListener("touchcancel", this._handleTouch), this._map._container.removeEventListener("click", this._handleTouch), L.DomEvent.off(this._map._container, "wheel", this._handleScroll, this), L.DomEvent.off(this._map, "mouseover", this._handleMouseOver, this), L.DomEvent.off(this._map, "mouseout", this._handleMouseOut, this), L.DomEvent.off(this._map, "movestart", this._handleDragging, this), L.DomEvent.off(this._map, "move", this._handleDragging, this), L.DomEvent.off(this._map, "moveend", this._handleDragging, this);
        },
        _handleDragging: function(a) {
            "movestart" == a.type || "move" == a.type ? t = !0 : "moveend" == a.type && (t = !1);
        },
        _disableInteractions: function() {
            this._map.dragging.disable(), this._map.scrollWheelZoom.disable(), this._map.tap && this._map.tap.disable();
        },
        _enableInteractions: function() {
            this._map.dragging.enable(), this._map.scrollWheelZoom.enable(), this._map.tap && this._map.tap.enable();
        },
        _setupPluginOptions: function() {
            this._map.options.gestureHandlingText && (this._map.options.gestureHandlingOptions.text = this._map.options.gestureHandlingText);
        },
        _setLanguageContent: function() {
            var a;
            if (this._map.options.gestureHandlingOptions && this._map.options.gestureHandlingOptions.text && this._map.options.gestureHandlingOptions.text.touch && this._map.options.gestureHandlingOptions.text.scroll && this._map.options.gestureHandlingOptions.text.scrollMac) a = this._map.options.gestureHandlingOptions.text;
            else {
                var t = this._getUserLanguage();
                t || (t = "en"), o[t] && (a = o[t]), a || -1 === t.indexOf("-") || (t = t.split("-")[0], a = o[t]), a || (a = o[t = "en"]);
            }
            var e = !1;
            0 <= navigator.platform.toUpperCase().indexOf("MAC") && (e = !0);
            var l = a.scroll;
            e && (l = a.scrollMac), this._map._container.setAttribute("data-gesture-handling-touch-content", a.touch), this._map._container.setAttribute("data-gesture-handling-scroll-content", l);
        },
        _getUserLanguage: function() {
            return navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage;
        },
        _handleTouch: function(a) {
            for(var t = [
                "leaflet-control-minimap",
                "leaflet-interactive",
                "leaflet-popup-content",
                "leaflet-popup-content-wrapper",
                "leaflet-popup-close-button",
                "leaflet-control-zoom-in",
                "leaflet-control-zoom-out"
            ], e = !1, l = 0; l < t.length; l++)L.DomUtil.hasClass(a.target, t[l]) && (e = !0);
            e ? L.DomUtil.hasClass(a.target, "leaflet-interactive") && "touchmove" === a.type && 1 === a.touches.length ? (L.DomUtil.addClass(this._map._container, "leaflet-gesture-handling-touch-warning"), this._disableInteractions()) : L.DomUtil.removeClass(this._map._container, "leaflet-gesture-handling-touch-warning") : "touchmove" === a.type || "touchstart" === a.type ? 1 === a.touches.length ? (L.DomUtil.addClass(this._map._container, "leaflet-gesture-handling-touch-warning"), this._disableInteractions()) : (a.preventDefault(), this._enableInteractions(), L.DomUtil.removeClass(this._map._container, "leaflet-gesture-handling-touch-warning")) : L.DomUtil.removeClass(this._map._container, "leaflet-gesture-handling-touch-warning");
        },
        _isScrolling: !1,
        _handleScroll: function(a) {
            a.metaKey || a.ctrlKey ? (a.preventDefault(), L.DomUtil.removeClass(this._map._container, "leaflet-gesture-handling-scroll-warning"), this._map.scrollWheelZoom.enable()) : (L.DomUtil.addClass(this._map._container, "leaflet-gesture-handling-scroll-warning"), this._map.scrollWheelZoom.disable(), clearTimeout(this._isScrolling), this._isScrolling = setTimeout(function() {
                for(var a = document.getElementsByClassName("leaflet-gesture-handling-scroll-warning"), t = 0; t < a.length; t++)L.DomUtil.removeClass(a[t], "leaflet-gesture-handling-scroll-warning");
            }, this._map.options.gestureHandlingOptions.duration));
        },
        _handleMouseOver: function(a) {
            this._enableInteractions();
        },
        _handleMouseOut: function(a) {
            t || this._disableInteractions();
        }
    });
    L.Map.addInitHook("addHandler", "gestureHandling", e), a.GestureHandling = e, a.default = e, Object.defineProperty(a, "__esModule", {
        value: !0
    });
});

});

})();
//# sourceMappingURL=ObjectsMap.b4276a80.js.map
